// extracted by mini-css-extract-plugin
export default {"requiredMark":"FieldWrapper_requiredMark__dDRC-"};